interface Props<T> {
  state: T
}

// TODO: Temporarily disabled before we can poperly test and debug this
export const WarnUnsavedChanges = <T extends object,>({  }: Props<T>) => {
  // const initialState = useRef(JSON.stringify(state));

  // useEffect(() => {
  //   const onBeforeUnload = (e) => {
  //     if (JSON.stringify(state) !== initialState.current) {
  //       e.preventDefault();
  //       e.returnValue = "";
  //     }
  //   };
  //   window.addEventListener("beforeunload", onBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", onBeforeUnload);
  //   };
  // }, [state]);

  return null;
};
